import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import StepCard from './StepCard';
import { CatalogProduct } from '../../types/entities';

interface SortableStepCardProps {
  id: string | number;
  stepOrder: number;
  totalSteps?: number;
  productCategoryName: string;
  instructions?: string;
  /** Repassados ao StepCard: sem eles o cartão não abre a gaveta de produtos. */
  productCategoryId?: string;
  productId?: string | null;
  userProductId?: string | null;
  productName?: string | null;
  productImageUrl?: string | null;
  onSelectProduct?: (product: CatalogProduct | null) => void;
  onRemove?: () => void;
}

/** StepCard arrastável — usado no editor de rotina e no modal de recomendação da IA. */
export default function SortableStepCard({
  id,
  stepOrder,
  totalSteps,
  productCategoryName,
  instructions,
  productCategoryId,
  productId,
  userProductId,
  productName,
  productImageUrl,
  onSelectProduct,
  onRemove,
}: SortableStepCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform) ?? undefined,
    transition,
    opacity: isDragging ? 0 : 1,
    position: 'relative',
    zIndex: isDragging ? 0 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style} className="group">
      <StepCard
        stepOrder={stepOrder}
        totalSteps={totalSteps}
        productCategoryName={productCategoryName}
        instructions={instructions}
        productCategoryId={productCategoryId}
        productId={productId}
        userProductId={userProductId}
        productName={productName}
        productImageUrl={productImageUrl}
        onSelectProduct={onSelectProduct}
        dragHandleProps={{ ...attributes, ...listeners }}
        onRemove={onRemove}
      />
    </div>
  );
}
